import { render } from "./ScrollableTabView.vue?vue&type=template&id=84d6dbc8&scoped=true&ts=true"
import script from "./ScrollableTabView.ts?vue&type=script&lang=ts"
export * from "./ScrollableTabView.ts?vue&type=script&lang=ts"

import "./ScrollableTabView.scss?vue&type=style&index=0&id=84d6dbc8&scoped=true&lang=scss"

import exportComponent from "/home/vsts/work/1/s/Frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84d6dbc8"]])

export default __exports__